import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehicleDutyCycleFigureService {

  constructor(private readonly httpClient: HttpClient) { }

  getTemperatureComfortZoneUsage(deviceSerialNumber: string[]):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'temperature-comfort-zone?batteryIdentifiers=' + deviceSerialNumber);
  }

}
